import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
// 👉 EDITÁ EL CONTENIDO DE ESTA SECCIÓN ABAJO
export const faqContent = {
  title: 'Preguntas Frecuentes',
  questions: [{
    q: '¿Cómo accedo al material una vez que pago?',
    a: 'Inmediatamente después de confirmar tu pago, vas a recibir un correo electrónico con el link de acceso a la plataforma donde podrás descargar los 6 tomos y bonos.'
  }, {
    q: '¿Necesito algún programa especial para editar los archivos?',
    a: 'No. La mayoría de los archivos están en PDF listos para imprimir, y las plantillas editables están diseñadas en Canva, una herramienta gratuita y muy fácil de usar.'
  }, {
    q: '¿El material sirve para mi perfil profesional?',
    a: 'Si trabajás en estimulación temprana, atención temprana, psicopedagogía, terapia ocupacional infantil o fonoaudiología pediátrica, el material está pensado para vos.'
  }, {
    q: '¿Tengo un tiempo límite para descargar el material?',
    a: 'No, el acceso es de por vida. Podés descargar el material a tu ritmo y volver a acceder cuando lo necesites.'
  }, {
    q: '¿Qué pasa si tengo dudas sobre cómo usar algo?',
    a: 'Contás con soporte prioritario por email. Nos escribís y te ayudamos a resolver cualquier inquietud que tengas con el material.'
  }]
};
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-brand-dark" data-id="element-83">
      <div className="max-w-3xl mx-auto" data-id="element-84">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-serif text-center mb-12 text-brand-light" data-id="element-85">
          {faqContent.title}
        </motion.h2>

        <div className="space-y-4" data-id="element-86">
          {faqContent.questions.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="border border-brand-cardBorder rounded-xl bg-brand-card overflow-hidden" data-id="element-87">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-88">
                  <span className="font-serif text-lg md:text-xl text-brand-light pr-4" data-id="element-89">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-brand-accent transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-90" />
                </button>

                <AnimatePresence data-id="element-91">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-92">
                      <div className="px-6 pb-6 text-brand-light/70 font-sans leading-relaxed" data-id="element-93">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}